<template>
  <div class="menu">
    <div class="menu__bar">
      <v-layout
        v-for="(item, i) in allowedRoutes"
        :key="i"
        :style="{
          display:
            !checkConditions(item)
              ? 'none'
              : 'flex',
        }"
        align-center
        justify-center
        row
        fill-height
      >
        <v-menu
          :class="
            'm-auto' + !item.dropdown
              ? ' menu__without-drop_down'
              : ' menu__drop-down'
          "
          :open-on-hover="!touchable"
          :menu-props="{ nudgeBottom: '-6' }"
          :close-on-click="false"
          :close-on-content-click="false"
          v-model="open['menu-' + i]"
          z-index="1000000"
          offset-y
        >
          <v-btn
            slot="activator"
            :id="'menu-' + i"
            @click="linkClicked(item)"
            flat
            small
            class="menu__btn"
          >
            <div class="menu__bar__item__icon">
              <i
                :class="'bexsicon-' + item.icon"
                :style="{ color: item.color }"
              />
            </div>
            <div class="menu__bar__item__title">{{ item.title }}</div>
          </v-btn>

          <v-list
            dense
            v-if="
              item.dropdown &&
              ((item.meta.dropDownConditions &&
                !item.meta.dropDownConditions.find(
                  (o) => conditions[o] === false
                )) ||
                !item.meta.dropDownConditions)
            "
          >
            <menu-units-select
              v-if="item.meta.unitsSelect && units.length > 1"
            ></menu-units-select>
            <div v-for="(itemDropDown, j) in item.dropdown" :key="j">
              <v-list-tile
                :class="{
                  '--with-hover': itemDropDown.path,
                }"
                v-if="checkConditions(itemDropDown)"
                :inactive="!itemDropDown.path"
                @click="linkClicked(itemDropDown, i)"
              >
                <v-list-tile-title class="menu__item">{{
                  itemDropDown.title
                }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                :class="{ '--with-hover': subdivision.path }"
                v-for="(subdivision, k) in filterByConditions(
                  itemDropDown.subdivision
                )"
                :key="k"
                @click="linkClicked(subdivision, i)"
              >
                <v-list-tile-title
                  class="pl-1 menu__bar__item__dropdown__divison__item menu__item"
                  >{{ subdivision.title }}</v-list-tile-title
                >
              </v-list-tile>
            </div>
          </v-list>
        </v-menu>
      </v-layout>
    </div>
  </div>
</template>

<script>
import enums from '@/utils/enums';
import MenuUnitsSelect from '@/components/unitsSelect/MenuUnitsSelect';
import { DOCS, NEWS_VIDEOS, UNIT, CONFIG, EVENTS } from '../../utils/constants';

export default {
  components: {
    MenuUnitsSelect
  },
  computed: {
    conditions() {
      return {
        hasGeneralDocs: this.$store.getters[DOCS.HAS_GENERAL_DOCS],
        hasLegalDocs: this.$store.getters[DOCS.HAS_LEGAL_DOCS],
        hasDocs:
          this.$store.getters[DOCS.HAS_GENERAL_DOCS] ||
          this.$store.getters[DOCS.HAS_LEGAL_DOCS] ||
          this.$store.getters[DOCS.HAS_OWNER_DOCS] ||
          this.$store.getters[DOCS.HAS_SYNDIC_DOCS],
        hasOwnerDocs: this.$store.getters[DOCS.HAS_OWNER_DOCS],
        hasNewsVideos: this.$store.getters[NEWS_VIDEOS.HAS_VIDEOS],
        showInConstruction: this.$store.getters[UNIT.GET_SHOW_IN_CONSTRUCTION],
        showDecorated: this.$store.getters[UNIT.GET_SHOW_DECORATED],
        notIndirectContract: !this.$store.getters[UNIT.GET_IS_INDIRECT],
        showDiscounts: this.$store.getters[UNIT.GET_DISCOUNT_LIST].length > 0,
        showBankFinancing:
          this.$store.getters[CONFIG.GET_JUNIX_BANK_FINANCING_BASE_URL].length >
            0 && this.$store.getters[UNIT.GET_IS_SETTLED] != true,
        showKeyDeliveryOption:
          !this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate && // ? does not have Keys delivered
          !!(this.$store.getters[EVENTS.GET_AGI] || {})._id && // ? has AGI Event
          !!(this.$store.getters[EVENTS.GET_KEYDELIVERY] || {})._id, // ? has Key delivery event
        hasInspection: this.checkInspection,
        hasSyndicDocs: this.$store.getters[DOCS.HAS_SYNDIC_DOCS]
      };
    },
    excludedModules() {
      return this.$store.getters[CONFIG.GET_NAVIGATION_RULES].excludeModules;
    },
    checkInspection() {
      return !!this.$store.getters[EVENTS.GET_INSPECTION];
    },
    allowedRoutes() {
      return this.routes.filter(item => {
        return (
          this.hasPermissionToView(item) &&
          (item.meta.module !== 'enterprise' || !this.isExceptionProduct)
        );
      });
    }
  },
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      open: {},
      menuOpened: ''
    };
  },
  methods: {
    checkConditions(item) {
      if (!item.meta) return true;
      if (item.mustHaveChildren) {
        const validChildren = item.dropdown.filter(child =>
          this.checkConditions(child)
        );
        if (validChildren.length === 0) return false;
      }
      const moduleBlocked = this.excludedModules.find(
        module => item.meta.module === module
      );
      if (moduleBlocked) {
        return false;
      }
      const hasConditions =
        (item.meta.conditions &&
          !item.meta.conditions.find(o => this.conditions[o] === false)) ||
        !item.meta.conditions;
      return hasConditions;
    },

    linkClicked(item, i) {
      this.open['menu-' + i] = !this.open['menu-' + i];
      if (item.path) this.$router.push(item.path);
      else if (item.vuexLink) {
        if (item.openForm) {
          this.$store.commit(item.vuexLink);
        } else {
          const link = this.$store.getters[item.vuexLink];
          window.open(link, '_blank');
        }
      }
    },
    filterByConditions(array) {
      return array
        ? array.filter(item => {
            return (
              (item.meta.conditions &&
                !item.meta.conditions.find(
                  condition => this.conditions[condition] === false
                )) ||
              !item.meta.conditions
            );
          })
        : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  z-index: 99999;
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-top: 2px solid #fff;
  max-width: 1366px;
  margin: auto;

  &__drop-down {
    border-radius: 5px;
    font-size: 12px;
    >>> .menuable__content__active {
      box-shadow: var(--box-shadow);
    }
  }

  &__without-drop_down {
    >>> .menuable__content__active {
      box-shadow: none;
    }
  }

  &__item {
    height: 24px;
    line-height: 24px;
    position: relative;
    text-align: left;
    font-size: 14px;
    color: var(--light-dark-color) !important;
  }

  &__btn {
    font-weight: 400;
    color: var(--light-dark-color) !important;
    font-size: 14px;

    &:before {
      display: none;
    }
  }
  .--with-hover {
    &:hover {
      .menu__bar__item__title,
      .v-list__tile__title {
        font-weight: 500;
        text-shadow: 0px 0px 1px #00000077;
      }
    }
  }
  &__bar {
    display: flex;
    width: 100%;

    border-top: 1px solid #ececec;
    padding-top: 0.5em;
    margin: 0 auto;

    &__item {
      &:hover > &__dropdown {
        display: block;
      }
      &__icon {
        // flex: .4;
        font-size: 1.5em;
        text-align: right;
        padding: 0 0.25em;
      }

      &__title {
        text-align: left;
        // flex: .6;
        padding: 0.5em 0;
        font-size: 0.9em;
      }

      &__dropdown {
        display: none;
        width: 150%;
        position: absolute;
        background-color: #fff;
        box-shadow: var(--box-shadow);
        border-radius: 3px;
        top: 100%;
        left: 0;

        &__item {
          font-weight: 400;
          border-radius: 0;
          width: 100%;
          text-align: left;
          padding: 5px 10px;
          transition: 300ms all ease;
        }

        &__divison {
          font-weight: 400;
          border-radius: 0;
          width: 100%;
          text-align: left;
          &__item {
            &::before {
              content: '• ';
              color: var(--brand-color);
              font-weight: var(--font-weight);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Menu.vue